document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.site-header__search-container').forEach(container => {
    const form = container.querySelector('form');
    const input = container.querySelector('input[type="search"]');
    const resultsDiv = container.querySelector('.predictive-search__results');
    let timeout = null;

    if (!input || !resultsDiv) return;

    input.addEventListener('input', () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        const term = input.value.trim();
        if (!term.length) { closeResults(); return; }
        fetchResults(term);
      }, 300);
    });

    form.addEventListener('submit', (e) => {
      if (!input.value.trim().length) e.preventDefault();
    });

    document.addEventListener('click', (e) => {
      if (!container.contains(e.target)) closeResults();
    });

    function fetchResults(term) {
      resultsDiv.innerHTML = '<div class="predictive-search__loading">Searching...</div>';
      openResults();
      fetch(`/search/suggest?q=${encodeURIComponent(term)}&resources[type]=product,collection,query&section_id=predictive-search`)
        .then(res => res.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const markup = doc.querySelector('#shopify-section-predictive-search').innerHTML;
          resultsDiv.innerHTML = markup;
        })
        .catch(console.error);
    }

    function openResults() {
      resultsDiv.style.display = 'block';
      setTimeout(() => resultsDiv.classList.add('is-open'), 10);
    }

    function closeResults() {
      resultsDiv.classList.remove('is-open');
      setTimeout(() => { resultsDiv.style.display = 'none'; }, 250);
    }
  });
});
